import React from 'react';
import {CcgAppIconProps} from './types';

export const CcgAppIcon = ({size}: CcgAppIconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		style={{minWidth: size || 34}}
		viewBox="0 0 64 64"
		fill="none">
		<rect width="64" height="64" fill="#1539AA" />
		<path
			d="M14.5926 20.501C12.8907 23.4458 14.9044 27.0056 19.9916 28.9621C22.6561 29.9862 27.1111 30.2021 30.0173 29.4169C29.2464 26.5079 26.8365 22.755 24.6183 20.9558C20.3849 17.5232 16.2946 17.5561 14.5926 20.501Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 8.5C28.3054 8.5 26.0557 12.3215 26.9796 18.1597C27.4644 21.2175 29.6798 25.5182 31.9938 27.8194C34.3079 25.5167 36.5233 21.2175 37.0081 18.1597C37.9335 12.323 35.6823 8.5 31.9938 8.5Z"
			fill="#FF222B"
		/>
		<path
			d="M49.4094 20.511C47.7117 17.5647 43.6199 17.529 39.3837 20.9572C37.164 22.7521 34.7498 26.5036 33.9775 29.4126C36.8823 30.1993 41.3373 29.989 44.0032 28.9664C49.0919 27.0156 51.1084 23.4572 49.4094 20.511Z"
			fill="#FF4E05"
		/>
		<path
			d="M31.9938 44.5C34.2636 44.5 35.6494 42.1473 35.0802 38.5546C34.7813 36.6724 33.4183 34.0251 31.9938 32.6092C30.5694 34.0265 29.2064 36.6724 28.9075 38.5546C28.3383 42.1473 29.7241 44.5 31.9938 44.5Z"
			fill="#FFCC23"
		/>
		<path
			d="M19.7156 37.4848C20.8497 39.4513 23.58 39.4756 26.4075 37.1873C27.8892 35.9888 29.501 33.4859 30.0159 31.5422C28.0765 31.0173 25.1031 31.1575 23.324 31.8397C19.9273 33.1412 18.5814 35.5168 19.7156 37.4848Z"
			fill="#FF8800"
		/>
		<path
			d="M44.2735 37.4905C45.4091 35.5254 44.0661 33.1484 40.6709 31.8426C38.8917 31.1575 35.9183 31.0145 33.979 31.5394C34.4938 33.4816 36.1028 35.9859 37.5816 37.1873C40.4077 39.4785 43.1379 39.4571 44.2735 37.4905Z"
			fill="#FF8800"
		/>
		<path
			d="M26.7881 47.5447H29.5238C29.9475 47.5447 30.3143 47.6248 30.6243 47.785C30.9395 47.9451 31.1798 48.1673 31.3451 48.4515C31.5156 48.7305 31.6008 49.0456 31.6008 49.397C31.6008 49.7328 31.5078 50.0583 31.3218 50.3735C31.1358 50.6835 30.8646 50.9134 30.5081 51.0632L31.8643 52.8612H30.5081L29.3378 51.257H27.8963V52.8612H26.7881V47.5447ZM29.3766 50.2805C29.7021 50.2805 29.9578 50.203 30.1438 50.048C30.335 49.893 30.4306 49.6786 30.4306 49.4047C30.4306 49.1412 30.3376 48.9294 30.1516 48.7692C29.9656 48.6039 29.6969 48.5212 29.3456 48.5212H27.8963V50.2805H29.3766Z"
			fill="white"
		/>
		<path
			d="M34.8661 52.9697C34.1892 52.9697 33.6364 52.8302 33.2076 52.5512C32.7787 52.2671 32.523 51.8692 32.4403 51.3577L33.4013 51.0787C33.453 51.3991 33.6054 51.6471 33.8586 51.8227C34.1169 51.9932 34.4502 52.0785 34.8583 52.0785C35.2407 52.0785 35.5377 52.0191 35.7496 51.9002C35.9666 51.7762 36.0751 51.6031 36.0751 51.381C36.0751 51.1846 36.0157 51.0374 35.8968 50.9392C35.778 50.8411 35.592 50.7713 35.3388 50.73L34.2848 50.5517C33.701 50.4536 33.2722 50.2831 32.9983 50.0402C32.7245 49.7922 32.5876 49.4512 32.5876 49.0172C32.5876 48.6866 32.678 48.4024 32.8588 48.1647C33.0448 47.9271 33.3032 47.7462 33.6338 47.6222C33.9697 47.4931 34.3572 47.4285 34.7963 47.4285C35.406 47.4285 35.9097 47.5551 36.3076 47.8082C36.7054 48.0614 36.956 48.4127 37.0593 48.8622L36.1138 49.18C36.0415 48.9061 35.8917 48.6943 35.6643 48.5445C35.437 48.3946 35.1477 48.3197 34.7963 48.3197C34.4657 48.3197 34.2047 48.374 34.0136 48.4825C33.8224 48.591 33.7268 48.7486 33.7268 48.9552C33.7268 49.1516 33.794 49.2936 33.9283 49.3815C34.0627 49.4693 34.2693 49.5365 34.5483 49.583L35.4241 49.7225C36.0596 49.8206 36.5168 49.9989 36.7958 50.2572C37.08 50.5156 37.2221 50.8772 37.2221 51.3422C37.2221 51.8589 37.0102 52.2593 36.5866 52.5435C36.1681 52.8276 35.5946 52.9697 34.8661 52.9697Z"
			fill="white"
		/>
	</svg>
);
